export function getSkuTrackingParams(itemParams, skuId) {
    const askingPrice = (itemParams.askingPrices || {})[skuId];
    const priceType = (itemParams.priceTypes || {})[skuId];
    if (askingPrice && priceType) {
        return {
            price: askingPrice,
            askingPrice,
            priceType,
        };
    }
    return {};
}
